const accessReducers = {
  userAccessRequestSuccess: (user, payload: { nextRegStep: string }) => ({
    ...user,
    nextRegStep: payload.nextRegStep
  }),

  userResetPasswordSuccess: (
    user,
    payload: {
      nextRegStep: string;
      user: any;
    }
  ) => ({
    ...user,
    nextRegStep: 'login',
    tempPhoneNumber: payload.user?.phoneNumber
  }),

  userLtaResetPasswordSuccess: (
    user,
    payload: {
      nextRegStep: string;
      user: any;
    }
  ) => {
    return {
      ...user,
      nextRegStep: 'login',
      tempPhoneNumber: payload.user?.phoneNumber
    };
  },

  userConfirmCodeSuccess: (
    user,
    payload: { preregisteredUser: any; action: string }
  ) => ({
    ...user,
    preregisteredUser: payload.preregisteredUser,
    role: payload.preregisteredUser
      ? payload.preregisteredUser.role
      : user.role,
    isParentInvitedByChild:
      payload.preregisteredUser && payload.preregisteredUser.role === 'parent',
    isChildInvitedByParent:
      payload.preregisteredUser && payload.preregisteredUser.role === 'child',
    needsAccessRequest: false,
    nextRegStep: payload.preregisteredUser
      ? payload.preregisteredUser.role !== 'child'
        ? payload.action
        : payload.preregisteredUser.nextRegisterStep // If a second userrover, do the register thing. Didn't want to break invited-child flow
      : payload.action
  }),

  userLoginSuccess: (
    user,
    payload: {
      user: any;
      token: string;
    }
  ) => {
    let nextRegStep = payload.user.nextRegisterStep;
    if (payload.user.nextRegisterStep === 'complete') {
      if (payload.user.role === 'child') {
        nextRegStep = 'complete_child';
      }
    }
    return {
      ...user,
      nextRegStep,
      role: payload.user.role,
      tempPhoneNumber: payload.user.phoneNumber,
      registeredUser: {
        ...payload,
        token: payload.token
      }
    };
  },
  userLoginFailure: user => ({
    ...user,
    registeredUser: null
  })
};

export default accessReducers;
